import React from 'react';
import {
  makeStyles,
  shorthands,
  Text,
  Card,
  CardHeader,
  Title3,
  tokens,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    ...shorthands.padding('20px'),
    backgroundColor: tokens.colorNeutralBackground1,
  },
  card: {
    maxWidth: '800px',
    width: '100%',
  },
  content: {
    ...shorthands.padding('20px'),
  },
  section: {
    marginBottom: '20px',
  },
  sectionTitle: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    marginBottom: '10px',
    color: tokens.colorNeutralForeground1,
  },
  description: {
    color: tokens.colorNeutralForeground2,
    lineHeight: '1.6',
  },
});

function PolarisMachinesPage() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Card className={classes.card}>
        <CardHeader
          header={<Title3>Polaris Machine Management</Title3>}
          description="Manage and monitor Polaris machines"
        />
        <div className={classes.content}>
          <div className={classes.section}>
            <Text className={classes.sectionTitle}>Machine Management Features</Text>
            <Text className={classes.description}>
              On this page, you can view and manage the status, configuration, and performance metrics of all Polaris machines.
            </Text>
          </div>
          
          <div className={classes.section}>
            <Text className={classes.sectionTitle}>Key Features</Text>
            <Text className={classes.description}>
              • View machine list and status<br/>
              • Monitor machine performance metrics<br/>
              • Configure machine settings<br/>
              • View machine logs<br/>
              • Perform maintenance operations
            </Text>
          </div>
        </div>
      </Card>
    </div>
  );
}

export default PolarisMachinesPage;